export const itCustomerMessages = {
  'customer.auth.loginTitle': 'Accedi al tuo account',
  'customer.auth.signupTitle': 'Crea il tuo account',
  'customer.auth.loginSubtitle': 'Accedi per vedere i tuoi dati e completare acquisti in modo rapido.',
  'customer.auth.loginTrustHint':
    'Accedi a ordini, profilo, assistenza e privacy da un unica area cliente sicura.',
  'customer.auth.signupSubtitle': 'Inserisci i tuoi dati. Completerai la registrazione via email.',
  'customer.auth.signupTrustHint':
    'Crea il tuo profilo cliente per gestire acquisti, dati e assistenza in modo centralizzato.',
  'customer.auth.signupStep.personal': 'Anagrafica',
  'customer.auth.signupStep.contact': 'Contatti',
  'customer.auth.signupStep.security': 'Sicurezza',
  'customer.auth.signupStep.review': 'Conferma',
  'customer.auth.previousStep': 'Indietro',
  'customer.auth.nextStep': 'Continua',
  'customer.auth.displayName': 'Nome visualizzato',
  'customer.auth.personalData': 'Dati anagrafici',
  'customer.auth.contactData': 'Compila i dati di contatto e indirizzo.',
  'customer.auth.securityData': 'Dopo la conferma riceverai un email per attivare l account.',
  'customer.auth.signupPendingSuccess': 'Controlla la tua email per completare la registrazione.',
  'customer.auth.securityTitle': 'Sicurezza',
  'customer.auth.securityDescription': 'Nessuna password ora: attiverai il profilo tramite email.',
  'customer.auth.securityHint': 'Dopo la conferma riceverai un email per attivare l account.',
  'customer.auth.reviewTitle': 'Controlla i tuoi dati',
  'customer.auth.reviewDescription': 'Verifica le informazioni prima di creare l account.',
  'customer.auth.reviewEdit': 'Modifica',
  'customer.auth.turnstileHelper': 'Verifica di sicurezza richiesta',
  'customer.auth.turnstileRequired': 'Completa la verifica di sicurezza per continuare.',
  'customer.auth.signupFailure': 'Non siamo riusciti a creare l account. Riprova tra qualche secondo.',
  'customer.auth.signupSuccessTitle': 'Controlla la tua email',
  'customer.auth.signupSuccessDescription': 'Ti abbiamo inviato un link per completare la registrazione.',
  'customer.auth.signupSuccessLoginCta': 'Vai al login',
  'customer.auth.signupSuccessHomeCta': 'Torna alla home',
  'customer.auth.stepOf': 'Step {current} di {total}',
  'customer.auth.sidebarTitle': 'Stai creando il tuo account',
  'customer.auth.sidebarDescription': 'Completa i passaggi e attiva il tuo profilo via email.',
  'customer.auth.firstName': 'Nome',
  'customer.auth.lastName': 'Cognome',
  'customer.auth.taxCode': 'Codice fiscale',
  'customer.auth.gender': 'Sesso',
  'customer.auth.genderPlaceholder': 'Seleziona',
  'customer.auth.gender.option.female': 'Donna',
  'customer.auth.gender.option.male': 'Uomo',
  'customer.auth.gender.option.nonBinary': 'Non binario',
  'customer.auth.gender.option.preferNot': 'Preferisco non indicarlo',
  'customer.auth.phone': 'Telefono',
  'customer.auth.phonePrefix': 'Prefisso',
  'customer.auth.phonePrefixPlaceholder': 'Seleziona prefisso',
  'customer.auth.phonePrefixSearchPlaceholder': 'Cerca prefisso',
  'customer.auth.phonePrefixNoResults': 'Nessun prefisso trovato',
  'customer.auth.phoneNumber': 'Numero',
  'customer.auth.residentialAddress': 'Indirizzo di residenza',
  'customer.auth.addressStreet': 'Via/Piazza',
  'customer.auth.addressStreetNumber': 'Numero civico',
  'customer.auth.addressCity': 'Citta',
  'customer.auth.addressPostalCode': 'CAP',
  'customer.auth.addressProvince': 'Provincia',
  'customer.auth.addressCountry': 'Paese',
  'customer.auth.countrySearchPlaceholder': 'Cerca paese',
  'customer.auth.countryNoResults': 'Nessun paese trovato',
  'customer.auth.loginIdentifier': 'Email o username',
  'customer.auth.loginIdentifierPlaceholder': 'nome@dominio.it oppure username',
  'customer.auth.loginCardTitle': 'Bentornato',
  'customer.auth.loginCardSubtitle': 'Accedi per continuare',
  'customer.auth.loginInvalidFeedback': 'Credenziali non valide. Controlla email e password.',
  'customer.auth.loginSecureAccess': 'Accesso sicuro',
  'customer.auth.login.2fa.title': 'Verifica in due passaggi',
  'customer.auth.login.2fa.subtitle': 'Inserisci il codice OTP o un recovery code per completare l’accesso.',
  'customer.auth.login.2fa.codeLabel': 'Codice di verifica',
  'customer.auth.login.2fa.codePlaceholder': 'Codice OTP o recovery code',
  'customer.auth.login.2fa.submit': 'Verifica e continua',
  'customer.auth.login.2fa.submitting': 'Verifica in corso...',
  'customer.auth.login.2fa.passkey': 'Usa passkey',
  'customer.auth.login.2fa.passkeySubmitting': 'Apertura passkey...',
  'customer.auth.login.2fa.passkeyHint': 'Se hai già salvato un dispositivo fidato, puoi usarlo adesso.',
  'customer.auth.login.2fa.invalidCode': 'Codice non valido o scaduto.',
  'customer.auth.login.2fa.back': 'Torna al login',
  'customer.auth.forgotPassword': 'Password dimenticata?',
  'customer.auth.forgotPassword.title': 'Recupera la password',
  'customer.auth.forgotPassword.subtitle':
    "Inserisci l'email associata al tuo account e ti invieremo un link per reimpostare la password.",
  'customer.auth.forgotPassword.submitCta': 'Invia link di reset',
  'customer.auth.forgotPassword.submittingCta': 'Invio in corso...',
  'customer.auth.forgotPassword.backToLogin': 'Torna al login',
  'customer.auth.forgotPassword.successTitle': 'Controlla la tua email',
  'customer.auth.forgotPassword.successBody':
    "Se l'indirizzo e registrato, riceverai un link per reimpostare la password.",
  'customer.auth.forgotPassword.successHint': 'Controlla anche la cartella spam o promozioni.',
  'customer.auth.resetPassword.title': 'Reimposta la password',
  'customer.auth.resetPassword.subtitle': 'Inserisci una nuova password per il tuo account',
  'customer.auth.resetPassword.submitCta': 'Aggiorna password',
  'customer.auth.resetPassword.submittingCta': 'Aggiornamento in corso...',
  'customer.auth.resetPassword.missingToken': 'Link non valido o incompleto',
  'customer.auth.resetPassword.invalidTokenError': 'Token non valido o scaduto',
  'customer.auth.resetPassword.expiredTitle': 'Link scaduto',
  'customer.auth.resetPassword.expiredDescription':
    'Il link per reimpostare la password è scaduto. Richiedi un nuovo link.',
  'customer.auth.resetPassword.invalidTitle': 'Link non valido',
  'customer.auth.resetPassword.invalidDescription': 'Il link utilizzato non è valido o è già stato usato.',
  'customer.auth.resetPassword.requestNewLinkCta': 'Richiedi nuovo link',
  'customer.auth.resetPassword.submitError': 'Non siamo riusciti ad aggiornare la password. Riprova.',
  'customer.auth.resetPassword.successTitle': 'Password aggiornata',
  'customer.auth.resetPassword.successBody': 'La tua password è stata aggiornata con successo',
  'customer.auth.resetPassword.backToLogin': 'Torna al login',
  'customer.auth.resetPassword.goToLogin': 'Vai al login',
  'customer.auth.activate.title': 'Attiva il tuo account',
  'customer.auth.activate.subtitle': 'Imposta una password per completare la registrazione.',
  'customer.auth.activate.onboarding.title': 'Sei quasi pronto',
  'customer.auth.activate.onboarding.subtitle':
    'Attiva il tuo account per iniziare a usare il tuo profilo cliente.',
  'customer.auth.activate.onboarding.orders': 'Accesso ai tuoi ordini',
  'customer.auth.activate.onboarding.payments': 'Pagamenti sicuri con Stripe',
  'customer.auth.activate.onboarding.support': 'Assistenza dedicata',
  'customer.auth.activate.formTitle': 'Imposta la tua password',
  'customer.auth.activate.formSubtitle': 'Completa la registrazione',
  'customer.auth.activate.setupTitle': 'Configura il tuo account',
  'customer.auth.activate.setupSubtitle':
    'Imposta le credenziali e scegli le opzioni di sicurezza per completare la registrazione.',
  'customer.auth.activate.check.password': 'Password sicura',
  'customer.auth.activate.check.security': 'Sicurezza account',
  'customer.auth.activate.check.twoFactor': 'Verifica in due passaggi opzionale',
  'customer.auth.activate.contextNote':
    'Hai ricevuto questa email perché hai creato un account su Emporion Store.',
  'customer.auth.activate.cardTitle': 'Completa la registrazione',
  'customer.auth.activate.cardSubtitle':
    'Scegli una password sicura e configura le impostazioni principali del tuo account.',
  'customer.auth.activate.loadingTitle': 'Verifica del link in corso',
  'customer.auth.activate.loadingBody': 'Controlliamo la validità del link di attivazione.',
  'customer.auth.activate.section.password': 'Password',
  'customer.auth.activate.requirementsTitle': 'Requisiti password',
  'customer.auth.activate.section.security': 'Sicurezza account',
  'customer.auth.activate.section.securitySubtitle':
    'Dopo l’accesso potrai gestire 2FA, sessioni attive, recovery code e passkey dal profilo.',
  'customer.auth.activate.section.twoFactor': 'Verifica in due passaggi',
  'customer.auth.activate.section.twoFactorSubtitle':
    'Puoi aggiungere un livello di protezione extra al tuo account.',
  'customer.auth.activate.twoFactor.foundationNote':
    'La verifica in due passaggi è disponibile nelle impostazioni sicurezza dopo il primo accesso.',
  'customer.auth.activate.requirements.length': 'Almeno 8 caratteri',
  'customer.auth.activate.requirements.letter': 'Una lettera maiuscola o minuscola',
  'customer.auth.activate.requirements.number': 'Un numero',
  'customer.auth.activate.requirements.match': 'Le password coincidono',
  'customer.auth.activate.passwordValid': 'Password valida',
  'customer.auth.activate.optionalBadge': 'Opzionale',
  'customer.auth.activate.twoFactor.openCta': 'Configura 2FA',
  'customer.auth.activate.twoFactor.modal.title': 'Configura verifica in due passaggi',
  'customer.auth.activate.twoFactor.modal.subtitle':
    'Completa il setup inserendo il codice generato dalla tua app di autenticazione.',
  'customer.auth.activate.twoFactor.modal.setupKeyLabel': 'Setup key',
  'customer.auth.activate.twoFactor.modal.codeLabel': 'Codice di verifica',
  'customer.auth.activate.twoFactor.modal.codePlaceholder': 'Inserisci codice a 6 cifre',
  'customer.auth.activate.twoFactor.modal.cancel': 'Annulla',
  'customer.auth.activate.twoFactor.modal.confirm': 'Attiva 2FA',
  'customer.auth.activate.twoFactor.modal.activating': 'Attivazione...',
  'customer.auth.activate.twoFactor.modal.backendPending':
    'Configurazione 2FA pronta lato UI. Integrazione backend in arrivo.',
  'customer.auth.activate.completeRegistrationCta': 'Completa registrazione',
  'customer.auth.activate.profileSettingsNote': 'Potrai modificare queste impostazioni dal tuo profilo.',
  'customer.auth.activate.submitCta': 'Attiva account e continua',
  'customer.auth.activate.submittingCta': 'Attivazione in corso...',
  'customer.auth.activate.trustFooter': '🔐 I tuoi dati sono protetti e non condivisi.',
  'customer.auth.activate.missingToken': 'Link di attivazione non valido o incompleto',
  'customer.auth.activate.invalidTokenError': 'Token non valido o scaduto',
  'customer.auth.activate.expiredTitle': 'Link scaduto',
  'customer.auth.activate.expiredDescription':
    "Il link di attivazione è scaduto. Richiedi un nuovo link per completare la registrazione.",
  'customer.auth.activate.recovery.expiredSubtitle':
    "Il link di attivazione è scaduto. Puoi richiederne uno nuovo.",
  'customer.auth.activate.recovery.invalidSubtitle':
    "Il link non è più valido, ma puoi facilmente richiederne uno nuovo.",
  'customer.auth.activate.recovery.leftEyebrow': 'AREA CLIENTE',
  'customer.auth.activate.recovery.leftTitle': 'Continua la registrazione',
  'customer.auth.activate.recovery.leftSubtitle':
    'Il link non è più valido, ma puoi richiederne uno nuovo e completare l’attivazione in modo sicuro.',
  'customer.auth.activate.recovery.nextStepsTitle': 'Cosa succede ora',
  'customer.auth.activate.recovery.nextStepOne': 'Verifichiamo la proprietà dell’account',
  'customer.auth.activate.recovery.nextStepTwo': 'Ti inviamo un nuovo link sicuro',
  'customer.auth.activate.recovery.nextStepThree': 'Completi la registrazione in pochi secondi',
  'customer.auth.activate.recovery.trustNote':
    'Per motivi di sicurezza non mostriamo lo stato dell’account. Se l’indirizzo è valido, riceverai un nuovo link.',
  'customer.auth.activate.recovery.securityPanelTitle': 'Protezione account',
  'customer.auth.activate.recovery.securityPanelItemOne': 'Link monouso',
  'customer.auth.activate.recovery.securityPanelItemTwo': 'Scadenza automatica',
  'customer.auth.activate.recovery.securityPanelItemThree': 'Verifica email obbligatoria',
  'customer.auth.activate.recovery.helper':
    'Per completare la registrazione, richiedi un nuovo link d’attivazione.',
  'customer.auth.activate.recovery.cardTitle': 'Richiedi un nuovo link',
  'customer.auth.activate.recovery.cardEyebrow': 'VERIFICA ACCOUNT',
  'customer.auth.activate.recovery.cardSubtitle': 'Inserisci l’email usata durante la registrazione.',
  'customer.auth.activate.recovery.cardSubtitleExpired':
    'Inserisci la tua email per ricevere una nuova attivazione.',
  'customer.auth.activate.recovery.cardSubtitleInvalid':
    'Inserisci la tua email e ti invieremo un nuovo link se l’account è ancora attivabile.',
  'customer.auth.activate.recovery.submitCta': 'Invia link di attivazione',
  'customer.auth.activate.recovery.submittingCta': 'Invio in corso...',
  'customer.auth.activate.recovery.submitHint':
    'Il link sarà valido per 30 minuti.',
  'customer.auth.activate.recovery.securityNote':
    'Non riveliamo se un account esiste o è ancora attivabile.',
  'customer.auth.activate.recovery.successTitle': 'Controlla la tua email',
  'customer.auth.activate.recovery.successBody':
    'Se l’indirizzo è valido, abbiamo inviato un nuovo link d’attivazione.',
  'customer.auth.activate.recovery.successHint': 'Il link è valido per 30 minuti.',
  'customer.auth.activate.recovery.successSpamHint':
    'Controlla anche la cartella spam o promozioni.',
  'customer.auth.activate.recovery.rateLimit': 'Troppe richieste. Riprova tra qualche minuto.',
  'customer.auth.activate.recovery.error': 'Errore temporaneo. Riprova.',
  'customer.auth.activate.resendCta': 'Invia nuovo link',
  'customer.auth.activate.resendingCta': 'Invio in corso...',
  'customer.auth.activate.resendSuccess': 'Nuovo link inviato. Controlla la tua email.',
  'customer.auth.activate.resendError': 'Non siamo riusciti a inviare un nuovo link. Riprova.',
  'customer.auth.activate.invalidTitle': 'Link non valido',
  'customer.auth.activate.invalidDescription': 'Il link utilizzato non è valido o è già stato usato.',
  'customer.auth.activate.submitError': 'Non siamo riusciti ad attivare l’account. Riprova.',
  'customer.auth.activate.successTitle': 'Account attivato',
  'customer.auth.activate.successBody': 'Account attivato. Effettua l’accesso.',
  'customer.auth.activate.backToLogin': 'Torna al login',
  'customer.auth.activate.goToLogin': 'Vai al login',
  'customer.auth.forgotPasswordUnavailable': 'Recupero password non ancora disponibile.',
  'customer.auth.forgotPasswordHint': 'Funzionalita disponibile prossimamente.',
  'customer.auth.email': 'Email',
  'customer.auth.password': 'Password',
  'customer.auth.password.show': 'Mostra',
  'customer.auth.password.hide': 'Nascondi',
  'customer.auth.trust.payments': 'Pagamenti sicuri con Stripe',
  'customer.auth.trust.paymentsDescription': 'Protezione completa e crittografia su ogni transazione.',
  'customer.auth.trust.orders': 'Storico ordini sempre disponibile',
  'customer.auth.trust.ordersDescription': 'Accesso immediato ai tuoi acquisti e alle conferme pagamento.',
  'customer.auth.trust.support': 'Assistenza dedicata',
  'customer.auth.trust.supportDescription': 'Supporto rapido dal tuo account cliente con storico richieste.',
  'customer.auth.preview.label': 'Anteprima area cliente',
  'customer.auth.preview.recentOrder': 'Ordine recente',
  'customer.auth.preview.paymentStatus': 'Pagamento',
  'customer.auth.preview.shippingStatus': 'Spedizione',
  'customer.auth.preview.paid': 'Pagato',
  'customer.auth.preview.shipped': 'Spedito',
  'customer.auth.passwordConfirm': 'Conferma password',
  'customer.auth.displayNamePlaceholder': 'Mario Rossi',
  'customer.auth.firstNamePlaceholder': 'Mario',
  'customer.auth.lastNamePlaceholder': 'Rossi',
  'customer.auth.taxCodePlaceholder': 'RSSMRA85M01H501Z',
  'customer.auth.phonePlaceholder': '333 1234567',
  'customer.auth.residentialAddressPlaceholder': 'Via Roma 10, Milano',
  'customer.auth.addressStreetPlaceholder': 'Via Roma',
  'customer.auth.addressStreetNumberPlaceholder': '10',
  'customer.auth.addressCityPlaceholder': 'Milano',
  'customer.auth.addressPostalCodePlaceholder': '20100',
  'customer.auth.addressProvincePlaceholder': 'MI',
  'customer.auth.addressCountryPlaceholder': 'Italia',
  'customer.auth.country.option.it': 'Italia',
  'customer.auth.country.option.ch': 'Svizzera',
  'customer.auth.country.option.fr': 'Francia',
  'customer.auth.country.option.de': 'Germania',
  'customer.auth.country.option.es': 'Spagna',
  'customer.auth.country.option.pt': 'Portogallo',
  'customer.auth.country.option.gb': 'Regno Unito',
  'customer.auth.country.option.us': 'Stati Uniti',
  'customer.auth.emailPlaceholder': 'nome@dominio.it',
  'customer.auth.passwordPlaceholder': 'Almeno 8 caratteri',
  'customer.auth.passwordConfirmPlaceholder': 'Ripeti la password',
  'customer.auth.passwordStrength.title': 'Sicurezza password',
  'customer.auth.passwordStrength.weak': 'Debole',
  'customer.auth.passwordStrength.medium': 'Media',
  'customer.auth.passwordStrength.strong': 'Forte',
  'customer.auth.loginCta': 'Accedi',
  'customer.auth.signupCta': 'Crea account',
  'customer.auth.hasAccount': 'Hai gia un account?',
  'customer.auth.missingAccount': 'Non hai ancora un account?',
  'customer.auth.toLogin': 'Vai al login',
  'customer.auth.toSignup': 'Registrati',
  'customer.auth.requiredLegend': '* Campo obbligatorio',
  'customer.auth.validation.requiredField': 'Campo obbligatorio.',
  'customer.auth.validation.personalIncomplete': 'Completa nome, cognome, codice fiscale ed email.',
  'customer.auth.validation.emailInvalid': 'Formato email non valido.',
  'customer.auth.validation.taxCodeInvalid': 'Codice fiscale non valido (11-16 caratteri alfanumerici).',
  'customer.auth.validation.genderRequired': 'Seleziona il sesso.',
  'customer.auth.validation.passwordMismatch': 'La conferma password non corrisponde.',
  'customer.auth.validation.passwordWeak': 'Password troppo debole: usa almeno 8 caratteri e una combinazione piu robusta.',
  'customer.auth.validation.phoneInvalid': 'Numero telefono non valido.',
  'customer.auth.validation.postalCodeInvalid': 'CAP non valido.',
  'customer.auth.validation.addressIncomplete': 'Completa tutti i campi dell indirizzo di residenza.',
  'customer.accessRequired.title': 'Accesso richiesto',
  'customer.accessRequired.description': 'Devi effettuare il login cliente per vedere questa sezione.',
  'customer.accessRequired.contextTitle': 'Accedi per continuare',
  'customer.accessRequired.contextDescription':
    'Per accedere alla tua area cliente e visualizzare ordini, spedizioni e fatture, effettua il login.',
  'customer.accessRequired.cardDescription':
    'Entra nell area cliente per proseguire con le tue operazioni in modo sicuro.',
  'customer.accessRequired.trust.orders': 'Storico ordini',
  'customer.accessRequired.trust.tracking': 'Tracking spedizioni',
  'customer.accessRequired.trust.support': 'Assistenza dedicata',
  'customer.initializing': 'Caricamento area cliente...',

  'customer.dashboard.accountData': 'Dati account',
  'customer.dashboard.profileData': 'Dati anagrafici',
  'customer.dashboard.addressesTitle': 'Indirizzi',
  'customer.dashboard.addressesDescription': 'Gestisci indirizzi di fatturazione e spedizione.',
  'customer.dashboard.nextSteps': 'Prossimi step',
  'customer.dashboard.username': 'Username',
  'customer.dashboard.firstName': 'Nome',
  'customer.dashboard.lastName': 'Cognome',
  'customer.dashboard.taxCode': 'Codice fiscale',
  'customer.dashboard.phone': 'Telefono',
  'customer.dashboard.residentialAddress': 'Residenza',
  'customer.dashboard.billingAddress': 'Indirizzo fatturazione',
  'customer.dashboard.shippingAddress': 'Indirizzo spedizione',
  'customer.dashboard.lastLogin': 'Ultimo accesso',
  'customer.dashboard.device': 'Dispositivo',
  'customer.dashboard.deviceUnavailable': 'Non disponibile',
  'customer.dashboard.toOrders': 'Vai allo storico ordini',
  'customer.dashboard.toSupport': 'Apri richiesta assistenza',
  'customer.dashboard.toPrivacy': 'Gestisci privacy e dati',
  'customer.dashboard.saveAddresses': 'Salva indirizzi',
  'customer.dashboard.savingAddresses': 'Salvataggio in corso...',
  'customer.dashboard.addressesSaved': 'Indirizzi aggiornati con successo.',
  'customer.dashboard.addressesSaveError': 'Salvataggio indirizzi non riuscito.',

  'customer.orders.title': 'I tuoi ordini',
  'customer.orders.subtitle': 'Storico ordini associato al tuo account',
  'customer.orders.continueShopping': 'Continua a comprare',
  'customer.orders.searchPlaceholder': 'Cerca per numero ordine o prodotto',
  'customer.orders.loading': 'Caricamento ordini...',
  'customer.orders.syncInProgress': 'Aggiornamento in corso…',
  'customer.orders.emptyTitle': 'Non hai ancora effettuato ordini',
  'customer.orders.emptyDescription': 'Quando completerai il checkout, qui vedrai lo storico ordini.',
  'customer.orders.emptyCta': 'Scopri prodotti',
  'customer.orders.noMatchTitle': 'Nessun ordine corrisponde ai filtri applicati',
  'customer.orders.noMatchDescription': 'Rimuovi o modifica i filtri per visualizzare altri ordini.',
  'customer.orders.order': 'Ordine',
  'customer.orders.createdAt': 'Creato il {date}',
  'customer.orders.items': 'Articoli',
  'customer.orders.status': 'Stato',
  'customer.orders.total': 'Totale',
  'customer.orders.detailCta': 'Vedi dettagli ordine',
  'customer.orders.rebuyCta': 'Compra di nuovo',
  'customer.orders.supportCta': 'Richiedi supporto',
  'customer.orders.productFallback': 'Prodotto non disponibile',
  'customer.orders.productsLabel': 'prodotti',
  'customer.orders.paymentMethod': 'Metodo pagamento',
  'customer.orders.paymentMethodFallback': 'Pagamento gestito da Stripe',
  'customer.orders.sort.label': 'Ordinamento',
  'customer.orders.sort.recent': 'Piu recenti',
  'customer.orders.sort.oldest': 'Piu vecchi',
  'customer.orders.sort.priceDesc': 'Prezzo alto -> basso',
  'customer.orders.sort.priceAsc': 'Prezzo basso -> alto',
  'customer.orders.resultsCount': '{count} ordini',
  'customer.orders.pagination.perPage': 'Righe',
  'customer.orders.pagination.summary': '{from}-{to} di {total}',
  'customer.orders.pagination.previous': 'Precedente',
  'customer.orders.pagination.next': 'Successivo',

  'customer.orderDetail.title': 'Dettaglio ordine',
  'customer.orderDetail.idLabel': 'ID ordine: {id}',
  'customer.orderDetail.backToOrders': 'Torna agli ordini',
  'customer.orderDetail.loading': 'Caricamento dettaglio ordine...',
  'customer.orderDetail.toOrders': 'Vai alla lista ordini',
  'customer.orderDetail.createdAt': 'Creato il',
  'customer.orderDetail.updatedAt': 'Aggiornato il',
  'customer.orderDetail.paidAt': 'Pagato il',
  'customer.orderDetail.cancelledAt': 'Annullato il',
  'customer.orderDetail.subtotal': 'Subtotale',
  'customer.orderDetail.paymentMethod': 'Metodo pagamento',
  'customer.orderDetail.paymentMethodFallback': 'Pagamento gestito da Stripe',
  'customer.orderDetail.itemsList': 'Righe ordine',
  'customer.orderDetail.itemsEmpty': 'Nessun articolo presente.',
  'customer.orderDetail.invoices': 'Fatture',
  'customer.orderDetail.invoicesSubtitle': 'Documenti fiscali disponibili per questo ordine.',
  'customer.orderDetail.invoicesSubtitleSingle': '1 documento fiscale disponibile',
  'customer.orderDetail.invoicesSubtitleMany': '{count} documenti fiscali disponibili',
  'customer.orderDetail.invoicesLoading': 'Caricamento fatture...',
  'customer.orderDetail.invoicesEmpty': 'Nessuna fattura disponibile al momento per questo ordine.',
  'customer.orderDetail.invoicesEmptyHint': 'I documenti fiscali appariranno qui quando saranno generati.',
  'customer.orderDetail.invoiceDate': 'Fattura del {invoiceDate}. Disponibile dal {uploadedAt}',
  'customer.orderDetail.invoiceIssuedAt': 'Fattura del {date}',
  'customer.orderDetail.invoiceAvailableAt': 'Disponibile dal {date}',
  'customer.orderDetail.openInvoice': 'Scarica PDF',
  'customer.orderDetail.openingInvoice': 'Scaricamento...',
  'customer.orderDetail.openInvoiceHint': 'Apri',
  'customer.orderDetail.openingInvoiceHint': 'Apro...',
  'customer.orderDetail.openInvoiceError': 'Errore apertura fattura',

  'customer.support.title': 'Assistenza',
  'customer.support.subtitle': 'Apri una richiesta e monitora lo stato delle tue segnalazioni.',
  'customer.support.newRequest': 'Nuova richiesta',
  'customer.support.history': 'Storico richieste',
  'customer.support.subject': 'Oggetto',
  'customer.support.subjectPlaceholder': 'Es. Problema con ordine',
  'customer.support.orderId': 'ID ordine (opzionale)',
  'customer.support.message': 'Messaggio',
  'customer.support.messagePlaceholder': 'Descrivi il problema nel dettaglio...',
  'customer.support.submit': 'Invia richiesta',
  'customer.support.submitting': 'Invio in corso...',
  'customer.support.loading': 'Caricamento richieste assistenza...',
  'customer.support.empty': 'Nessuna richiesta assistenza presente.',
  'customer.support.openedAt': 'Aperta: {date}',
  'customer.support.closedAt': 'Chiusa: {date}',
  'customer.support.order': 'Ordine: {orderNumber}',
  'customer.support.formSubtitle': 'Descrivi il problema e collega, se serve, un ordine.',
  'customer.support.historySubtitle': 'Monitora gli aggiornamenti delle richieste aperte e risolte.',
  'customer.support.orderIdPlaceholder': 'Es. ord_123456',
  'customer.support.previewFallback': 'Nessun dettaglio aggiuntivo nel messaggio.',
  'customer.support.categoryLabel': 'Categoria',
  'customer.support.category.general': 'Generale',
  'customer.support.category.order': 'Ordine',
  'customer.support.category.shipping': 'Spedizione',
  'customer.support.category.payment': 'Pagamento',
  'customer.support.category.privacy': 'Privacy',
  'customer.support.priorityLabel': 'Priorita',
  'customer.support.priority.normal': 'Normale',
  'customer.support.priority.high': 'Alta',
  'customer.support.priority.urgent': 'Urgente',
  'customer.support.contextLinkedOrder': 'Richiesta collegata all ordine {orderRef}',
  'customer.support.contextOrderStatus': 'Stato ordine: {status}',
  'customer.support.contextMainProduct': 'Prodotto principale: {product}',
  'customer.support.kpi.open': 'Ticket aperti',
  'customer.support.kpi.inProgress': 'In lavorazione',
  'customer.support.kpi.resolved': 'Risolti',
  'customer.support.openTicketDetail': 'Apri dettaglio ticket',
  'customer.support.detailTitle': 'Dettaglio ticket',
  'customer.support.detailSubtitle': 'Ticket {ticketId}',
  'customer.support.backToList': 'Torna alla lista',
  'customer.support.detailNotFoundTitle': 'Ticket non trovato',
  'customer.support.detailNotFoundDescription':
    'Il ticket richiesto non e disponibile o non appartiene al tuo account.',
  'customer.support.detail.ticketId': 'ID ticket',
  'customer.support.detail.status': 'Stato',
  'customer.support.detail.updatedAt': 'Ultimo aggiornamento',
  'customer.support.detail.openedAt': 'Aperto il {date}',
  'customer.support.detail.customerMessage': 'Messaggio cliente',
  'customer.support.detail.supportReply': 'Risposta assistenza',
  'customer.support.detail.noReplyYet': 'Nessuna risposta disponibile al momento.',

  'customer.nav.overview': 'Panoramica',
  'customer.nav.overviewDescription': 'Stato account, KPI e azioni rapide',
  'customer.nav.orders': 'Ordini',
  'customer.nav.ordersDescription': 'Storico ordini e tracciamento stato',
  'customer.nav.support': 'Assistenza',
  'customer.nav.supportDescription': 'Richieste supporto e aggiornamenti',
  'customer.nav.privacy': 'Privacy e dati',
  'customer.nav.privacyDescription': 'Consensi, export e gestione account',
  'customer.nav.profile': 'Profilo e sicurezza',
  'customer.nav.profileDescription': 'Dati personali, accesso e sicurezza account',
  'customer.nav.addresses': 'Indirizzi',
  'customer.nav.addressesDescription': 'Residenza, fatturazione e spedizione',
  'customer.nav.preferences': 'Fatturazione e pagamenti',
  'customer.nav.preferencesDescription': 'Dati di fatturazione e sicurezza pagamenti',

  'customer.dashboard.heroTitle': 'Ciao {name}, bentornato',
  'customer.dashboard.heroSubtitle':
    'Gestisci account, ordini, assistenza e privacy da un unico spazio cliente.',
  'customer.dashboard.overview.title': 'Panoramica account',
  'customer.dashboard.overview.subtitle': 'Stato operativo e informazioni principali del tuo profilo.',
  'customer.dashboard.kpi.totalOrders': 'Ordini totali',
  'customer.dashboard.kpi.activeOrders': 'Ordini attivi',
  'customer.dashboard.kpi.openTickets': 'Ticket aperti',
  'customer.dashboard.kpi.savedAddresses': 'Indirizzi salvati',
  'customer.dashboard.kpi.exportState': 'Stato export dati',
  'customer.dashboard.kpi.customerCode': 'Codice cliente',
  'customer.dashboard.kpi.accountStatus': 'Stato account',
  'customer.dashboard.kpi.noData': 'N/D',
  'customer.dashboard.manageProfile': 'Gestisci profilo',
  'customer.dashboard.quickActions.title': 'Azioni rapide',
  'customer.dashboard.quickActions.subtitle': 'Accesso immediato alle operazioni piu frequenti.',
  'customer.dashboard.quickActions.ordersTitle': 'Visualizza ordini',
  'customer.dashboard.quickActions.ordersDescription': 'Controlla stato e dettagli degli ordini.',
  'customer.dashboard.quickActions.supportTitle': 'Contatta assistenza',
  'customer.dashboard.quickActions.supportDescription':
    'Apri una richiesta e segui la risposta del team.',
  'customer.dashboard.quickActions.privacyTitle': 'Gestisci privacy',
  'customer.dashboard.quickActions.privacyDescription': 'Aggiorna consensi e richieste GDPR.',
  'customer.dashboard.quickActions.profileTitle': 'Aggiorna profilo',
  'customer.dashboard.quickActions.profileDescription': 'Mantieni aggiornati dati personali e contatti.',
  'customer.dashboard.quickActions.addressesTitle': 'Aggiorna indirizzi',
  'customer.dashboard.quickActions.addressesDescription':
    'Modifica indirizzi di residenza, fatturazione e spedizione.',
  'customer.dashboard.activity.title': 'Attivita recente',
  'customer.dashboard.activity.subtitle': 'Ultimi eventi rilevanti del tuo account.',
  'customer.dashboard.activity.empty': 'Nessuna attivita recente disponibile.',
  'customer.dashboard.activity.orderCreated': 'Ordine creato',
  'customer.dashboard.activity.orderStatus': 'Stato ordine aggiornato',
  'customer.dashboard.activity.supportCreated': 'Nuovo ticket assistenza',
  'customer.dashboard.activity.supportFallback': 'Aggiornamento ticket',
  'customer.dashboard.activity.privacyRequest': 'Richiesta privacy',
  'customer.dashboard.activity.privacyStatus': 'Stato richiesta privacy',
  'customer.dashboard.activity.lastLogin': 'Ultimo accesso',
  'customer.dashboard.essentialData.title': 'Dati essenziali',
  'customer.dashboard.essentialData.subtitle': 'Informazioni principali del tuo account cliente.',

  'customer.orders.filters.title': 'Filtri ordini',
  'customer.orders.filters.subtitle': 'Cerca rapidamente ordini per stato o numero.',
  'customer.orders.filters.searchLabel': 'Cerca ordine',
  'customer.orders.filters.searchPlaceholder': 'Numero ordine o riferimento',
  'customer.orders.filters.open': 'Filtri',
  'customer.orders.filters.close': 'Chiudi filtri',
  'customer.orders.filters.date.label': 'Data',
  'customer.orders.filters.date.all': 'Tutte le date',
  'customer.orders.filters.date.last30': 'Ultimi 30 giorni',
  'customer.orders.filters.date.last3Months': 'Ultimi 3 mesi',
  'customer.orders.filters.date.lastYear': 'Ultimo anno',
  'customer.orders.filters.date.custom': 'Personalizzato',
  'customer.orders.filters.date.from': 'Da',
  'customer.orders.filters.date.to': 'A',
  'customer.orders.filters.status.label': 'Stato ordine',
  'customer.orders.filters.price.label': 'Prezzo',
  'customer.orders.filters.price.min': 'Minimo',
  'customer.orders.filters.price.max': 'Massimo',
  'customer.orders.filters.price.minPlaceholder': 'Es. 50',
  'customer.orders.filters.price.maxPlaceholder': 'Es. 200',
  'customer.orders.filters.reset': 'Reset filtri',
  'customer.orders.filters.statusLabel': 'Stato',
  'customer.orders.filters.statusAll': 'Tutti gli stati',
  'customer.orders.kpi.total': 'Ordini totali',
  'customer.orders.kpi.totalMeta': 'Storico completo account',
  'customer.orders.kpi.processing': 'In lavorazione',
  'customer.orders.kpi.processingMeta': 'Ordini da completare',
  'customer.orders.kpi.latest': 'Ultimo ordine',
  'customer.orders.kpi.noData': 'Nessun ordine',

  'customer.profile.title': 'Profilo account',
  'customer.profile.subtitle': 'Aggiorna dati personali, contatti e informazioni anagrafiche.',
  'customer.profile.formTitle': 'Dati profilo',
  'customer.profile.formSubtitle': 'Le modifiche vengono applicate al tuo account cliente.',
  'customer.profile.save': 'Salva profilo',
  'customer.profile.saving': 'Salvataggio...',
  'customer.profile.saved': 'Profilo aggiornato con successo.',
  'customer.profile.saveError': 'Impossibile aggiornare il profilo.',
  'customer.profile.accountInfoTitle': 'Informazioni account',
  'customer.profile.accountId': 'ID account',
  'customer.profile.passkeys.title': 'Dispositivi fidati',
  'customer.profile.passkeys.subtitle': 'Aggiungi un dispositivo fidato per confermare l accesso piu velocemente.',
  'customer.profile.passkeys.add': 'Aggiungi passkey',
  'customer.profile.passkeys.loading': 'Attendi...',
  'customer.profile.passkeys.empty': 'Nessun dispositivo fidato salvato.',
  'customer.profile.passkeys.createdAt': 'Aggiunto il {date}',
  'customer.profile.passkeys.remove': 'Rimuovi',
  'customer.profile.passkeys.removing': 'Rimozione...',
  'customer.profile.passkeys.requiresTwoFactor': 'Attiva la 2FA prima di aggiungere una passkey.',
  'customer.profile.passkeys.notSupported': 'Questo browser non puo aggiungere una passkey.',
  'customer.profile.passkeys.deviceDefault': 'Dispositivo {count}',
  'customer.profile.passkeys.error.load': 'Impossibile caricare i dispositivi fidati.',
  'customer.profile.passkeys.error.add': 'Impossibile aggiungere questo dispositivo.',
  'customer.profile.passkeys.error.remove': 'Impossibile rimuovere questo dispositivo.',
  'customer.profile.passkeys.success.added': 'Dispositivo aggiunto con successo.',
  'customer.profile.passkeys.success.removed': 'Dispositivo rimosso con successo.',

  'customer.addresses.title': 'Indirizzi',
  'customer.addresses.subtitle': 'Gestisci residenza, fatturazione e spedizione.',
  'customer.addresses.formTitle': 'Rubrica indirizzi',
  'customer.addresses.formSubtitle': 'Mantieni aggiornati gli indirizzi usati negli ordini.',
  'customer.addresses.save': 'Salva indirizzi',
  'customer.addresses.saving': 'Salvataggio...',
  'customer.addresses.saved': 'Indirizzi aggiornati correttamente.',
  'customer.addresses.saveError': 'Errore durante il salvataggio degli indirizzi.',

  'customer.preferences.title': 'Fatturazione e pagamenti',
  'customer.preferences.subtitle':
    'Gestisci i dati usati per la fatturazione e visualizza le informazioni sui pagamenti.',
  'customer.preferences.banner.prefix': 'Pagamenti sicuri tramite',
  'customer.preferences.banner.brand': 'Stripe',
  'customer.preferences.banner.suffix': '- i dati della tua carta non vengono salvati',
  'customer.preferences.banner.tooltip':
    'Stripe è una piattaforma di pagamento sicura utilizzata da milioni di aziende nel mondo.',
  'customer.preferences.billing.title': 'Dati di fatturazione',
  'customer.preferences.billing.subtitle':
    'Inserisci i dati usati per la fatturazione dei tuoi ordini.',
  'customer.preferences.billing.firstName': 'Nome',
  'customer.preferences.billing.lastName': 'Cognome',
  'customer.preferences.billing.taxCode': 'Codice fiscale',
  'customer.preferences.billing.phone': 'Telefono (opzionale)',
  'customer.preferences.billing.email': 'Email di fatturazione (opzionale)',
  'customer.preferences.billing.useForNextOrders':
    'Usa questi dati per i prossimi ordini',
  'customer.preferences.billing.autoApplyHint':
    'Usati automaticamente nei prossimi ordini',
  'customer.preferences.billing.requiredFieldsError':
    'Compila nome, cognome e codice fiscale per continuare.',
  'customer.preferences.billing.taxCodeInvalid': 'Inserisci un codice fiscale valido (16 caratteri).',
  'customer.preferences.billing.emailInvalid': 'Inserisci una email valida.',
  'customer.preferences.billing.save': 'Salva dati',
  'customer.preferences.billing.saving': 'Salvataggio...',
  'customer.preferences.billing.saved': 'Dati di fatturazione aggiornati.',
  'customer.preferences.billing.toastSaved': 'Dati aggiornati con successo',
  'customer.preferences.billing.saveError': 'Impossibile salvare i dati di fatturazione.',
  'customer.preferences.address.title': 'Indirizzo principale',
  'customer.preferences.address.subtitle':
    'Indirizzo principale usato per ordini e fatturazione.',
  'customer.preferences.address.summaryLabel': 'Indirizzo principale',
  'customer.preferences.address.nameFallback': 'Intestatario indirizzo',
  'customer.preferences.address.usageTitle': 'Usato per:',
  'customer.preferences.address.usageShipping': 'spedizione',
  'customer.preferences.address.usageBilling': 'fatturazione',
  'customer.preferences.address.manage': 'Gestisci indirizzi',
  'customer.preferences.address.emptyTitle': 'Nessun indirizzo associato',
  'customer.preferences.address.emptyDescription':
    'Aggiungi un indirizzo per completare più velocemente i prossimi ordini.',
  'customer.preferences.address.emptyCta': 'Vai agli indirizzi',
  'customer.preferences.security.title': 'Pagamenti sicuri',
  'customer.preferences.security.subtitle': 'Informazioni utili sulla sicurezza dei pagamenti.',
  'customer.preferences.security.lead':
    'I pagamenti sono gestiti in modo sicuro tramite Stripe. Non salviamo i dati della tua carta.',
  'customer.preferences.security.point1': 'Pagamenti protetti da Stripe',
  'customer.preferences.security.point2': 'Nessun dato carta salvato sul sito',
  'customer.preferences.security.point3': 'Checkout sicuro',
  'customer.preferences.lastPayment.title': 'Ultimo pagamento',
  'customer.preferences.lastPayment.subtitle': "Dettagli dell'ultimo pagamento registrato.",
  'customer.preferences.lastPayment.amount': 'Importo',
  'customer.preferences.lastPayment.date': 'Data',
  'customer.preferences.lastPayment.status': 'Stato',
  'customer.preferences.lastPayment.order': 'Ordine',

  'customer.privacy.title': 'Privacy e dati',
  'customer.privacy.subtitle':
    'Gestisci dati personali, preferenze comunicazioni e richieste GDPR da un unico punto.',
  'customer.privacy.loading': 'Caricamento sezione privacy...',
  'customer.privacy.unavailable': 'Sezione privacy non disponibile al momento.',
  'customer.privacy.refresh': 'Aggiorna',
  'customer.privacy.refreshing': 'Aggiornamento...',
  'customer.privacy.accountStatusLabel': 'Stato account',
  'customer.privacy.exportStatus': 'Stato export',
  'customer.privacy.lastUpdated': 'Ultimo aggiornamento',
  'customer.privacy.quickLinksTitle': 'Azioni privacy rapide',
  'customer.privacy.quickLinksSubtitle': 'Gestisci le principali operazioni privacy in pochi click.',
  'customer.privacy.quickAction.exportTitle': 'Richiedi export',
  'customer.privacy.quickAction.exportDescription': 'Prepara un file con i tuoi dati account.',
  'customer.privacy.quickAction.profileTitle': 'Aggiorna dati personali',
  'customer.privacy.quickAction.profileDescription': 'Modifica anagrafica e recapiti.',
  'customer.privacy.quickAction.profileCta': 'Apri profilo',
  'customer.privacy.quickAction.preferencesTitle': 'Aggiorna preferenze',
  'customer.privacy.quickAction.preferencesDescription': 'Rivedi lingua e comunicazioni.',
  'customer.privacy.quickAction.preferencesCta': 'Apri preferenze',
  'customer.privacy.quickAction.deleteTitle': 'Elimina account',
  'customer.privacy.quickAction.deleteDescription': 'Avvia il processo di eliminazione sicura.',
  'customer.privacy.quickAction.deleteCta': 'Vai a eliminazione',
  'customer.privacy.requestExport': 'Richiedi export',
  'customer.privacy.accountStatus.deletionRequested': 'Eliminazione richiesta',
  'customer.privacy.accountStatus.deletionPending': 'Eliminazione in corso',
  'customer.privacy.unavailableTitle': 'Sezione privacy non disponibile',
  'customer.privacy.unavailableDescription':
    'Non siamo riusciti a caricare i dati privacy dell account. Riprova tra qualche istante.',
  'customer.privacy.accountStatus.active': 'Attivo',
  'customer.privacy.accountStatus.pendingDeletion': 'Eliminazione in corso',
  'customer.privacy.accountStatus.anonymized': 'Anonimizzato',
  'customer.privacy.accountStatus.deleted': 'Eliminato',
  'customer.privacy.overview.title': 'I tuoi dati',
  'customer.privacy.overview.description':
    'Panoramica stato privacy account e ultime modifiche ai dati personali.',
  'customer.privacy.overview.accountStatus': 'Stato account',
  'customer.privacy.overview.privacyUpdatedAt': 'Ultimo aggiornamento privacy',
  'customer.privacy.overview.dataOwner': 'Intestatario dati',
  'customer.privacy.export.title': 'Scarica i miei dati',
  'customer.privacy.export.description':
    'Richiedi un export completo di account, profilo, ordini, fatture, assistenza e preferenze privacy.',
  'customer.privacy.export.state': 'Stato export',
  'customer.privacy.export.expiresAt': 'Disponibile fino al',
  'customer.privacy.export.request': 'Richiedi export',
  'customer.privacy.export.requesting': 'Richiesta in corso...',
  'customer.privacy.export.download': 'Scarica export',
  'customer.privacy.export.downloading': 'Download in corso...',
  'customer.privacy.exportState.none': 'Nessuna richiesta',
  'customer.privacy.exportState.pending': 'In attesa',
  'customer.privacy.exportState.processing': 'In preparazione',
  'customer.privacy.exportState.ready': 'Pronto',
  'customer.privacy.exportState.expired': 'Scaduto',
  'customer.privacy.consents.title': 'Consensi e preferenze',
  'customer.privacy.consents.description':
    'Aggiorna i consensi opzionali per comunicazioni marketing e promozionali.',
  'customer.privacy.consents.mandatory': 'Privacy policy',
  'customer.privacy.consents.accepted': 'Accettata',
  'customer.privacy.consents.notAccepted': 'Non accettata',
  'customer.privacy.consents.acceptedAt': 'Accettata il',
  'customer.privacy.consents.marketingEmail':
    'Acconsento a ricevere comunicazioni email di marketing.',
  'customer.privacy.consents.promotionalNotifications':
    'Acconsento a ricevere aggiornamenti promozionali sui prodotti.',
  'customer.privacy.consents.save': 'Salva preferenze',
  'customer.privacy.consents.saving': 'Salvataggio...',
  'customer.privacy.profile.title': 'Dati personali',
  'customer.privacy.profile.description':
    'Verifica e aggiorna i dati anagrafici, i riferimenti di contatto e gli indirizzi.',
  'customer.privacy.profile.save': 'Salva dati personali',
  'customer.privacy.profile.saving': 'Salvataggio dati...',
  'customer.privacy.delete.title': 'Eliminazione account',
  'customer.privacy.delete.description':
    'Avvia il flusso di eliminazione account con conferma password obbligatoria.',
  'customer.privacy.delete.warningTitle': 'Attenzione',
  'customer.privacy.delete.warningBody':
    'L eliminazione account e irreversibile. Alcuni dati ordine possono essere mantenuti per obblighi fiscali e di legge.',
  'customer.privacy.delete.action': 'Richiedi eliminazione account',
  'customer.privacy.delete.modalTitle': 'Conferma eliminazione account',
  'customer.privacy.delete.modalDescription':
    'Per continuare inserisci la password attuale e conferma di aver compreso le conseguenze.',
  'customer.privacy.delete.passwordLabel': 'Password attuale',
  'customer.privacy.delete.confirmLabel':
    'Confermo di voler eliminare il mio account e comprendo che l operazione e irreversibile.',
  'customer.privacy.delete.cancel': 'Annulla',
  'customer.privacy.delete.submit': 'Conferma eliminazione',
  'customer.privacy.delete.submitting': 'Elaborazione...',
  'customer.privacy.activity.title': 'Attivita privacy recenti',
  'customer.privacy.activity.description':
    'Timeline richieste GDPR e azioni privacy relative al tuo account.',
  'customer.privacy.activity.empty': 'Nessuna attivita privacy registrata.',
  'customer.privacy.activity.createdAt': 'Creata il {date}',
  'customer.privacy.activity.typeExport': 'Richiesta export dati',
  'customer.privacy.activity.typeDeletion': 'Richiesta eliminazione account',

  'checkout.title': 'Checkout',
  'checkout.subtitle': 'Completa i dati di spedizione prima del pagamento sicuro.',
  'checkout.loadingSession': 'Preparazione sessione checkout...',
  'checkout.empty.title': 'Il carrello e vuoto',
  'checkout.empty.description': 'Aggiungi almeno un prodotto prima di continuare con il checkout.',
  'checkout.empty.ctaCart': 'Torna al carrello',
  'checkout.empty.ctaCatalog': 'Vai al catalogo',
  'checkout.progress.ariaLabel': 'Progresso checkout',
  'checkout.progress.mobileLabel': 'Step corrente',
  'checkout.progress.mobileCounter': '{current} / {total}',
  'checkout.step.cart': 'Carrello',
  'checkout.step.shipping': 'Spedizione',
  'checkout.step.billing': 'Fatturazione',
  'checkout.step.method': 'Metodo',
  'checkout.step.review': 'Riepilogo',
  'checkout.step.payment': 'Pagamento',
  'checkout.cta.continueCheckout': 'Continua checkout',
  'checkout.cta.saveAndContinue': 'Salva e continua',
  'checkout.cta.continue': 'Continua',
  'checkout.cta.saveMethod': 'Salva metodo',
  'checkout.cta.proceedToPayment': 'Procedi al pagamento',
  'checkout.cta.confirmBankTransferOrder': 'Conferma ordine con bonifico',
  'checkout.cta.edit': 'Modifica',
  'checkout.cta.back': 'Indietro',
  'checkout.cta.cancel': 'Annulla',
  'checkout.cta.retry': 'Riprova',
  'checkout.cta.backToCart': 'Torna al carrello',
  'checkout.cta.dismiss': 'Chiudi',
  'checkout.cta.goToOrders': 'Vai agli ordini',
  'checkout.field.firstName': 'Nome',
  'checkout.field.lastName': 'Cognome',
  'checkout.field.company': 'Azienda',
  'checkout.field.line1': 'Indirizzo',
  'checkout.field.line2': 'Interno / piano',
  'checkout.field.city': 'Citta',
  'checkout.field.postalCode': 'CAP',
  'checkout.field.region': 'Provincia / regione',
  'checkout.field.country': 'Codice paese (ISO2)',
  'checkout.field.phone': 'Telefono',
  'checkout.validation.required': '{field} obbligatorio.',
  'checkout.validation.postalCodeInvalid': 'CAP non valido.',
  'checkout.validation.countryInvalid': 'Il paese deve usare il codice ISO a 2 lettere (esempio IT).',
  'checkout.validation.phoneInvalid': 'Numero di telefono non valido.',
  'checkout.cartReview.title': 'Controllo carrello',
  'checkout.cartReview.description': 'Verifica i prodotti prima di inserire i dati di spedizione.',
  'checkout.shippingAddress.title': 'Indirizzo di spedizione',
  'checkout.shippingAddress.description': 'Inserisci i dati di destinazione della consegna.',
  'checkout.billingAddress.title': 'Indirizzo di fatturazione',
  'checkout.billingAddress.description': 'Scegli se la fatturazione coincide con la spedizione.',
  'checkout.billing.title': 'Opzioni fatturazione',
  'checkout.billing.sameAsShipping': 'Usa questo indirizzo anche per la fatturazione',
  'checkout.billing.useShippingAddress': 'Usa indirizzo di spedizione',
  'checkout.billing.useDifferentAddress': 'Usa indirizzo di fatturazione diverso',
  'checkout.billing.previewTitle': 'Anteprima fatturazione',
  'checkout.addressBook.title': 'Indirizzi salvati',
  'checkout.addressBook.addNew': 'Aggiungi nuovo indirizzo',
  'checkout.addressBook.defaultBadge': 'Predefinito',
  'checkout.addressBook.selectedBadge': 'Selezionato',
  'checkout.addressBook.panelAddTitle': 'Nuovo indirizzo',
  'checkout.addressBook.panelEditTitle': 'Modifica indirizzo',
  'checkout.addressBook.saveAddress': 'Salva indirizzo',
  'checkout.addressBook.panelMissingFields': 'Compila i campi obbligatori prima di salvare l indirizzo.',
  'checkout.shippingMethod.title': 'Metodo di spedizione',
  'checkout.shippingMethod.description': 'Scegli la velocita di consegna.',
  'checkout.shippingMethod.standard.label': 'Spedizione standard',
  'checkout.shippingMethod.standard.description': 'Consegna standard',
  'checkout.shippingMethod.standard.estimate': 'Consegna stimata: 3-5 giorni lavorativi',
  'checkout.shippingMethod.express.label': 'Spedizione express',
  'checkout.shippingMethod.express.description': 'Consegna prioritaria',
  'checkout.shippingMethod.express.estimate': 'Consegna stimata: 1-2 giorni lavorativi',
  'checkout.shippingMethod.recommended': 'Consigliato',
  'checkout.review.title': 'Riepilogo checkout',
  'checkout.review.description': 'Controlla indirizzi e importi prima del pagamento.',
  'checkout.review.products': 'Prodotti',
  'checkout.review.shippingAddress': 'Spedizione',
  'checkout.review.billingAddress': 'Fatturazione',
  'checkout.review.shippingMethod': 'Metodo',
  'checkout.review.paymentMethod': 'Pagamento',
  'checkout.review.totals': 'Totali',
  'checkout.review.subtotal': 'Subtotale',
  'checkout.review.shipping': 'Spedizione',
  'checkout.review.tax': 'Tasse',
  'checkout.review.discount': 'Sconto',
  'checkout.review.total': 'Totale',
  'checkout.review.notSelected': 'Non selezionato',
  'checkout.summary.title': 'Riepilogo ordine',
  'checkout.summary.show': 'Mostra',
  'checkout.summary.hide': 'Nascondi',
  'checkout.summary.securityTitle': 'Pagamento sicuro',
  'checkout.summary.securityBody': 'I pagamenti sono gestiti in modo sicuro da Stripe. I dati carta non transitano su questo shop.',
  'checkout.summary.statusPending': 'Sessione pagamento in attesa di conferma.',
  'checkout.summary.statusExpired': 'Sessione checkout scaduta. Riavvia dal carrello.',
  'checkout.summary.statusCancelled': 'Sessione checkout annullata.',
  'checkout.redirect.title': 'Reindirizzamento al pagamento sicuro',
  'checkout.redirect.description': 'Attendi mentre apriamo la sessione Stripe.',
  'checkout.error.sessionCreationFailed': 'Impossibile creare la sessione checkout.',
  'checkout.error.sessionLoadFailed': 'Impossibile caricare la sessione checkout.',
  'checkout.error.sessionExpired': 'La sessione checkout e scaduta. Riavvia dal carrello.',
  'checkout.error.emptyCart': 'Il carrello e vuoto. Aggiungi prodotti prima del checkout.',
  'checkout.error.invalidStep': 'Step non disponibile. Completa prima gli step precedenti.',
  'checkout.error.backendValidation': 'Dati checkout non validi. Controlla i campi evidenziati.',
  'checkout.error.confirmPaymentFailed': 'Impossibile avviare il pagamento. Riprova.',
  'checkout.error.generic': 'Errore checkout non previsto.',
  'checkout.completed.title': 'Checkout completato',
  'checkout.completed.description': 'Pagamento confermato. Apri lo storico ordini dalla dashboard.',
  'checkout.completed.bankTransferDescription':
    'Ordine acquisito. Il pagamento resta in attesa finché il bonifico non viene ricevuto e confermato.',
  'checkout.completed.bankTransferTitle': 'Istruzioni bonifico',
  'checkout.completed.beneficiary': 'Beneficiario',
  'checkout.completed.iban': 'IBAN',
  'checkout.completed.bank': 'Banca',
  'checkout.completed.amount': 'Importo',
  'checkout.completed.reference': 'Causale',
  'checkout.payment.provider.bankTransfer': 'Bonifico Bancario',
  'checkout.payment.provider.bankTransferDescription': 'Conferma manuale del pagamento dopo accredito.',
  'checkout.payment.provider.stripe': 'Carta (Stripe)',
  'checkout.payment.provider.stripeDescription': 'Pagamento online sicuro con redirect su Stripe.',

  'customer.placeholder.title': 'Sezione in preparazione',
  'customer.placeholder.description': 'La pagina /dashboard/{nestedPath} verra completata nelle prossime issue.',
  'customer.placeholder.back': 'Torna alla dashboard',
} as const
